import { getAxiosClient } from 'utils/axios';
import { handleApiError } from './utils';

export const AUTH_INIT = '@auth/INIT';
export const SET_PROFILE = '@auth/SET_PROFILE';
export const SET_USER = '@auth/SET_USER';

export const initAuth = { type: AUTH_INIT };

export const authProfile = (data) => ({ type: SET_PROFILE, data });

export const getUser = (userId) => async () => {
    const cli = getAxiosClient('AuthGetUser', {
        passthrough: (data) => ({ type: SET_USER, data })
    });
    try {
        const res = await cli.get(`/v1/users/${userId}`);
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};

export const getOrCreateUser = (userId, user) => async () => {
    const cli = getAxiosClient('AuthCreateUser', {
        passthrough: (data) => ({ type: SET_USER, data: data.data })
    });
    try {
        const res = await cli.post(`/v1/users/${userId}`, user);
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};

export const patchUser = (userId, user) => async () => {
    const cli = getAxiosClient('AuthPatchUser');
    try {
        const res = await cli.patch(`/v1/users/${userId}`, user);
        return res.data;
    } catch (e) {
        return handleApiError(e);
    }
};
